import dynamic from "next/dynamic";
const Campaign = dynamic(() => import("@/components/campaign/Campaign"));
import { useI18n } from "@/i18n/I18nProvider";
const PageHead = dynamic(() => import("@/components/PageHead"));



export default function ContactNewsletterPage() {
  const { t } = useI18n();

  return <>
      <PageHead />
      <Campaign type="contact-newsletter" title={t.Campaign.Title1} subTitle={t.Campaign.Title2} source={23} />
    </>;
}
